import {Component, Input, OnInit} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';

@Component({
    selector: 'app-dialog-step4-section-controller',
    templateUrl: './dialog-step4-section-controller.component.html',
    styleUrls: ['./dialog-step4-section-controller.component.scss']
})
export class DialogStep4SectionControllerComponent extends EditModalSectionBaseComponent implements OnInit {

    @Input() public forceFormValidationVisibility: boolean;

    public MyContainersTableIdEnum = MyContainersTableIdEnum;

    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

}
